var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingUserScope,
          expression: "loadingUserScope"
        }
      ]
    },
    [
      _vm.modifyUser
        ? _c("register-form", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingUser,
                expression: "loadingUser"
              }
            ],
            attrs: {
              addUser: _vm.addUser,
              modifyUser: _vm.modifyUser,
              modifyRole: _vm.modifyRole,
              modifyFromUser: _vm.modifyFromUser,
              userData: _vm.currentUser,
              roleId: _vm.roleId,
              academicAreas: _vm.academicAreas
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0566c149", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0566c149","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = null
// module chunks = 